import React, { Component } from 'react'
import PropTypes from 'prop-types'


export default class RadioGroup extends Component {

  static childContextTypes = {
    radioGroup: PropTypes.object,
  }

  static propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    ariaLabel: PropTypes.string,
    ariaLabelledBy: PropTypes.string,
  }

  getChildContext() {
    const { name, valueLink } = this.props

    return {
      radioGroup: {
        name, valueLink,
      },
    }
  }

  render() {
    const { children, className, ariaLabel, ariaLabelledBy } = this.props

    return (
      <div
        className={className}
        role="radiogroup"
        aria-label={ariaLabel}
        aria-labelledby={ariaLabelledBy}
      >
        {children}
      </div>
    )
  }
}
